// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-map-container[data-v-2c941e39] {\n  max-height: 100%;\n}\n.vue-map[data-v-2c941e39] {\n  max-height: 100%;\n}\n.pick__up-link[data-v-2c941e39] {\n  --text-opacity: 1;\n  color: #0046AA;\n  color: rgba(0, 70, 170, var(--text-opacity));\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
